// hooks/usePageTitle.ts
import { useEffect } from 'react';

export function usePageTitle(title: string, suffix = ' | Lokobee') {
  const fullTitle = title ? `${title}${suffix}` : 'Lokobee';

  useEffect(() => {
    // Update document title
    document.title = fullTitle;

    // Update Google Analytics page title
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('config', process.env.REACT_APP_MEASUREMENT_ID, {
        page_title: fullTitle
      });
    }

    return () => {
      document.title = 'Lokobee';
      // Reset Google Analytics on cleanup
      if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('config', process.env.REACT_APP_MEASUREMENT_ID, {
          page_title: 'Lokobee'
        });
      }
    };
  }, [fullTitle]);
}
